module.exports = __webpack_public_path__ + "static/media/Sarah_Keogh.ab0cdec5.jpg";